export default __webpack_public_path__ + "static/media/hk-logo-light.5b557000.svg";